import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { AppState, submissionSelector } from 'common/store/store';
import React from 'react';
import { useSelector } from 'react-redux';


export const SubmissionDescription = (props: { submissionId: number, onClose: () => void; }) => {

    const submission = useSelector((state: AppState) => submissionSelector.selectById(state, props.submissionId));

    if (!submission) return <></>;

    return <Dialog open={!!props.submissionId} onClose={() => props.onClose()}>
        <DialogTitle>{'Description du projet'}</DialogTitle>
        <DialogContent>
            <DialogContentText component={'div'}>
                <div>{submission.description?.split('\n').filter(p => p.trim() != '').map((p: string, index: number) => {
                    return <Typography key={index}>{p.trim()}</Typography>;
                })}</div>
            </DialogContentText>
        </DialogContent>
    </Dialog>;
};
